import * as systemConfigurationActions from '../actions/system-configuration.actions';
import { GeneralInformation } from '../models/system-configuration-model';
import * as lodash from 'lodash';

export interface State {
  generalInformationMap: Map<string, GeneralInformation>;
  loading: boolean;
}

export const INITIAL_STATE: State = {
  generalInformationMap: new Map<string, GeneralInformation>(),
  loading: false
}

export function reducer(state: State = INITIAL_STATE, action: systemConfigurationActions.Actions): State {
  switch (action.type) {
    case systemConfigurationActions.LOAD:
      {
        return {
          ...state,
          loading: true
        };
      }
    case systemConfigurationActions.LOAD_COMPLETE:
      {
        const info = lodash.cloneDeep(state.generalInformationMap);

        if (info.has(action.product)) {
          info[action.product] = action.payload;
        } else {
          info.set(action.product, action.payload);
        }

        return {
          ...state,
          generalInformationMap: info,
          loading: false
        };
      }
    default:
      {
        return state;
      }
  }

}
